import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faBell, faEnvelope, faUser } from '@fortawesome/pro-regular-svg-icons';
import CertificationImg from '../../../../assets/images/certification.svg';
import TrainingImg from '../../../../assets/images/training.svg';

const WidgetBox = ({ title, children, type, icon, noPadding, horizontal, backgroundIcon, floatingImg, titleLink }) => {
  const widgetClasses = classNames('cornerstone-widget', {
    'cornerstone-widget--horizontal': horizontal
  });

  const headerClasses = classNames('cornerstone-widget__header', {
    [`cornerstone-widget__header--${type}`]: !!type
  });

  const boxClasses = classNames('cornerstone-widget__box-content', {
    'cornerstone-widget__box-content--no-padding': noPadding,
    [`cornerstone-widget__box-content--background-${backgroundIcon}`]: !!backgroundIcon
  });

  const renderFloatingImage = () => {
    let faFloatingImag = null;

    switch (floatingImg) {
      case 'pin':
        faFloatingImag = CertificationImg;
        break;
      case 'flag':
        faFloatingImag = TrainingImg;
        break;
      default:
        return null;
    }

    return (
      <div className="cornerstone-widget__floating-image">
        <img src={faFloatingImag} alt="banner" />
      </div>
    );
  };

  const renderIcon = () => {
    let faIcon = null;

    switch (icon) {
      case 'bell':
        faIcon = faBell;
        break;
      case 'envelope':
        faIcon = faEnvelope;
        break;
      case 'clipboard':
        faIcon = faClipboardList;
        break;
      case 'user':
        faIcon = faUser;
        break;
      default:
        return null;
    }

    return (
      <span className="cornerstone-widget__icon">
        <FontAwesomeIcon icon={faIcon} />
      </span>
    )
  };

  const onTitleClickHandler = () => {
    if (!titleLink) {
      return null;
    }

    window.open(titleLink, '_blank');
  };

  return (
    <div className={widgetClasses}>
      <div className={headerClasses}>
        {renderIcon()}
        {renderFloatingImage()}
        <h3 style={{ cursor: titleLink ? 'pointer' : 'auto' }} onClick={onTitleClickHandler}>{title}</h3>
      </div>
      <div className={boxClasses}>
        {children}
      </div>
    </div>
  );
}

WidgetBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf([
    'meadow',
    'primary',
    'warning',
    'danger',
    'purple'
  ]),
  icon: PropTypes.oneOf([
    'bell',
    'envelope',
    'clipboard',
    'user'
  ]),
  noPadding: PropTypes.bool,
  backgroundIcon: PropTypes.oneOf([
    'books',
    'clipboard'
  ]),
  floatingImg: PropTypes.oneOf([
    'pin',
    'flag'
  ]),
  titleLink: PropTypes.string
};

WidgetBox.defaultProps = {
  icon: null,
  type: null,
  noPadding: false,
  backgroundIcon: null,
  floatingImg: null,
  titleLink: null
};

export default WidgetBox;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/components/widget-box.js